"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Option = exports.Header = exports.Content = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./DropDownMenu.scss");

require("./DropDownMenuDark.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DropDownMenu = function DropDownMenu(_ref) {
  var id = _ref.id,
      disabled = _ref.disabled,
      keepMenuOpen = _ref.keepMenuOpen,
      children = _ref.children,
      iconName = _ref.iconName,
      isUserMenu = _ref.isUserMenu;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var wrapperRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setActive(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-dd-container ' + (isUserMenu ? 'user-menu' : ''),
    ref: wrapperRef,
    id: id
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-dd-icon"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    disabled: disabled,
    onClick: function onClick() {
      return setActive(!active);
    },
    className: "gcl-dd-button"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: iconName
  }))), active && /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-dd-menu-container'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-dd-menu-wrap",
    onClick: function onClick() {
      return keepMenuOpen ? " " : setActive(false);
    }
  }, children)));
};

var Option = function Option(_ref2) {
  var onClick = _ref2.onClick,
      children = _ref2.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-dd-option",
    onClick: onClick
  }, children);
};

exports.Option = Option;

var Header = function Header(_ref3) {
  var title = _ref3.title,
      subtitle = _ref3.subtitle,
      _ref3$iconName = _ref3.iconName,
      iconName = _ref3$iconName === void 0 ? 'gcl-icon account' : _ref3$iconName;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-dd-header"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: iconName
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "title"
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "subtitle"
  }, subtitle));
};

exports.Header = Header;

var Content = function Content(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-dd-content"
  }, children);
};

exports.Content = Content;
DropDownMenu.propTypes = {
  id: _propTypes["default"].number,
  disabled: _propTypes["default"].bool,
  keepMenuOpen: _propTypes["default"].bool,
  iconName: _propTypes["default"].string,
  isUserMenu: _propTypes["default"].bool
};
DropDownMenu.defaultProps = {
  iconName: 'gcl-icon more'
};
var _default = DropDownMenu;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/DropDownMenu/DropDownMenu.js
// module id = 693
// module chunks = 0